import { combineDataProviders, DataProvider } from 'react-admin';
import { Resources } from '../types/Resources';
import { usersDataProvider } from './usersDataProvider';
import { promptDataProvider } from './promptDataProvider';
import { filesDataProvider } from './filesDataProvider';
import { historyDataProvider } from './historyDataProvider';
import { productProvider } from './productProvider';
import { filesProductPrivider } from './filesProductPrivider';
import { modelsProvider } from './modelsProvider';
import { chatsProvider } from './chatsProvider';
import { jivoChatsProvider } from './jivoChatsProvider';
import { categoryProvider } from './categoryProvider';
import { insalesProvider } from './insalesProvider';
import { insalesProductsProvider } from './insalesProductsProvider';

export const dataProvider = combineDataProviders((resource) => {
  const resourceData = resource as Resources;

  switch (resourceData) {
    case Resources.users:
      return usersDataProvider as DataProvider;
    case Resources.prompt:
      return promptDataProvider as DataProvider;
    case Resources.files:
      return filesDataProvider as DataProvider;
    case Resources.history:
      return historyDataProvider as DataProvider;
    case Resources.product:
      return productProvider as DataProvider;
    case Resources.files_product:
      return filesProductPrivider as DataProvider;
    case Resources.models:
      return modelsProvider as DataProvider;
    case Resources.chats:
      return chatsProvider as DataProvider;
    case Resources.jivo_chats:
      return jivoChatsProvider as DataProvider;
    case Resources.categories:
      return categoryProvider as DataProvider;
    case Resources.insales:
      return insalesProvider as DataProvider;
    case Resources.insales_products:
      return insalesProductsProvider as DataProvider;
    default:
      throw new Error(`Unsupported resource: ${resource}`);
  }
});
